// Vendor imports
const React = require('react')
// Client V2 common imports
const useClientEffect = require('client-v2/common/hooks/client-effect')
const { mediaQueries } = require('client-v2/common/utils/responsive')

/**
 * @param {string} mediaQuery
 * @returns {boolean}
 */
function useMatchMedia(mediaQuery) {
  const [ matches, setMatches ] = React.useState(false)
  useClientEffect(
    () => {
      const mql = matchMedia(
        mediaQuery in mediaQueries
        ? mediaQueries[mediaQuery]
        : mediaQuery
      )
      function updateMatches() {
        setMatches(mql.matches)
      }
      updateMatches()
      mql.addListener(updateMatches)
      return () => {
        mql.removeListener(updateMatches)
      }
    },
    [ mediaQuery, setMatches ]
  )
  return matches
}

module.exports = useMatchMedia
